<section class="cmn-innerpage-wrapper leave-apply-sec">
  <form [formGroup]="leaveApplyForm">
    <div class="leave-apply-wrapper">
      <div class="form-wrapper">
        <label for="">Leave type <span class="red">*</span></label>
        <mat-form-field>
          <mat-select placeholder="Select Type" formControlName="leaveType">
            <!-- <mat-option value="LocalLeave">Local Leave</mat-option> -->
            <mat-option value="MedicalLeave">Sick Leave</mat-option>
            <mat-option value="PaternityLeave">Paternity Leave</mat-option>
            <mat-option value="MaternityLeave">Maternity Leave</mat-option>
            <mat-option value="BereavementLeave">Bereavement Leave</mat-option>
            <mat-option value="FestivalLeave">Festival Leave</mat-option>
          </mat-select>
        </mat-form-field>
        <!-- <h2 *ngIf="selectedLeaveBalance">Balance: {{selectedLeaveBalance}}</h2> -->
        <div
        *ngIf="
          leaveApplyForm.get('leaveType')!.invalid &&
          leaveApplyForm.get('leaveType')!.touched
        "
        class="error"
      >
      Leave type is required.
      </div>
      </div>
      <div class="form-wrapper" *ngIf="leaveApplyForm.get('leaveType')?.value === 'BereavementLeave'">
        <label for="">Relation<span class="red">*</span></label>
        <mat-form-field>
          <mat-select placeholder="Select relation" formControlName="bereavedRelation">
            <mat-option value="spouse">Spouse</mat-option>
            <mat-option value="bloodRelative">Blood Relatives</mat-option>
          </mat-select>
        </mat-form-field>
        <!-- <h2 *ngIf="selectedLeaveBalance">Balance: {{selectedLeaveBalance}}</h2> -->
        <div
        *ngIf="
          leaveApplyForm.get('bereavedRelation')!.invalid &&
          leaveApplyForm.get('bereavedRelation')!.touched
        "
        class="error"
      >
        Relation is required.
      </div>
      </div>
      <div class="form-wrapper" *ngIf="!employeeId">
        <span>
            <label for="">Employee Name <span class="red">*</span></label>
        </span>
        <mat-form-field>
            <mat-select placeholder="Select Employee" formControlName="employeeId">
                <mat-option *ngFor="let employee of employees" [value]="employee?.id">
                    {{ employee?.firstName }}
                </mat-option>
            </mat-select> </mat-form-field>
        <div class="custom-error">
            <span>
                <mat-error *ngIf="
                 leaveApplyForm.get('employeeId')!?.touched &&
                 leaveApplyForm.get('employeeId')?.hasError('required')">
                    Employee is required
                </mat-error>
            </span>
        </div>
    </div>
      <div class="form-wrapper">
        <label for="">From Date <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            [matDatepickerFilter]="dateFilter"
            formControlName="startDate"
            [matDatepicker]="pickerFrom"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="pickerFrom"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerFrom></mat-datepicker>
        </mat-form-field>

        <div
        *ngIf="
          leaveApplyForm.get('startDate')!.invalid &&
          leaveApplyForm.get('startDate')!.touched
        "
        class="error"
      >
        From date is required.
      </div>
      </div>
      <div class="form-wrapper">
        <label for="">To Date <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            [matDatepicker]="pickerTo"
            formControlName="endDate"
            [matDatepickerFilter]="dateFilter"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="pickerTo"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerTo></mat-datepicker>
        </mat-form-field>
        <div
        *ngIf="
          leaveApplyForm.get('endDate')!.invalid &&
          leaveApplyForm.get('endDate')!.touched
        "
        class="error"
      >
        To date is required.
      </div>
      </div>

      <div class="form-wrapper">
        <label for="">Reason for Leave</label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Reason"
            formControlName="employeeComment"
          />
        </mat-form-field>
      </div>
    </div>

    <div class="documents-wrapper">
      <h2>Documents</h2>
      <div class="upload-wrapper">
        <div class="cmn-upload-box">
          <h4>Upload Documents (optional)</h4>
          <input
            #fileInput
            type="file"
            (change)="onFileSelected($event)"
            style="display: none"
          />
          <button class="cmn-choose-file-btn" (click)="fileInput.click()">
            <img
              src="assets/images/icons/icon-add-color.svg"
              alt="Icon Add"
            />Choose a File
          </button>
        </div>
      </div>
      <div class="uploaded-file" *ngIf="csvFile.length > 0">
        <div *ngFor="let file of csvFile; let i = index">
          <h6 (click)="onViewDocument(file)" style="cursor: pointer">
            {{ file.name }}
            <img
              src="assets/images/icons/icon-close.svg"
              alt="Close Icon"
              (click)="removeFile(i)"
            />
          </h6>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button (click)="onCancel()" class="cmn-cancel-btn">Cancel</button>
      <button (click)="onApplyLeave()" class="cmn-next-btn" [disabled]="isLoading">{{ isLoading ? 'Submitting...' :
                'Submit' }}</button>
    </div>
  </form>
</section>
